<template>
    <v-select
        :items="dropdown"
        label="Individual"
        v-model="selectedIndividual"
        return-object
        item-text="label"
        :error-messages="value.errors.get('owner')"
    ></v-select>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        props: {
            value: {
                required: true
            },
            showBeneficiaries: {
                required: false,
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                selectedIndividual: [],
                dropdown: [],
            }
        },
        mounted() {
            // Wait until the form is filled
            this.$nextTick(() => {
                this.filterDropdown(this.isAnnuity);
                this.findSelectedIndividual();
            })
        },
        methods: {
            // Show or hide beneficiaries from the dropdown menu
            filterDropdown(isAnnuity) {
                if (isAnnuity) {
                    this.dropdown = this.individualsDropdown.find(function(item) {
                        return item.beneficiary_id === null;
                    });

                    // Remove selected beneficiary
                    if (this.value.beneficiary_id !== null) {
                        this.value.beneficiary_id = null;
                        this.selectedIndividual = this.individualsDropdown[0];
                    }

                    // Set beneficiary owner to individual owner
                    if (this.value.owner === 3) {
                        this.value.owner = 0;
                    }
                } else {
                    this.dropdown = this.individualsDropdown;
                }
            },
            findSelectedIndividual() {
                let vm = this;

                // Iav Account creation
                if (this.value.id === null) {
                    this.selectedIndividual = this.individualsDropdown[0];
                } else if (this.value.individual_id !== null) {
                    // Individual owner
                    this.selectedIndividual = this.individualsDropdown.find(function(item) {
                        return item.individual_id === vm.value.individual_id;
                    })
                } else if (this.value.beneficiary_id !== null) {
                    // Beneficiary owner
                    this.selectedIndividual = this.individualsDropdown.find(function(item) {
                        return item.beneficiary_id === vm.value.beneficiary_id;
                    })
                } else {
                    // Regular owner (Joint, Trust, etc)
                    this.selectedIndividual = this.individualsDropdown.find(function(item) {
                        return item.owner === vm.value.owner;
                    })
                }
            }
        },
        watch: {
            /**
             * Update the parent form object
             * @param newIndividual
             */
            selectedIndividual(newIndividual) {
                if (newIndividual === undefined) {
                    return;
                }

                this.value.owner = newIndividual.owner;
                this.value.individual_id = newIndividual.individual_id;

                if (this.showBeneficiaries) {
                    this.value.beneficiary_id = newIndividual.beneficiary_id;
                }
            },
            isAnnuity(newIsAnnuity) {
                this.filterDropdown(newIsAnnuity);
            }
        },
        computed: {
            ...mapState('individuals', ['individualsDropdown']),
            isAnnuity() {
                return (this.value.is_annuity !== undefined && this.value.is_annuity === 'true') || !this.showBeneficiaries;
            }
        },
    }
</script>
